import image from './image.vue';
export const frameworks = {
    /** 图片 */
    image,
};
